import { PathItem } from "../types/PathItem";

export const getPathItem = (path: string): PathItem => {
  const pathItem: PathItem = {
    folder: path.substring(0, path.lastIndexOf("\\")),
    fileName: path.substring(path.lastIndexOf("\\") + 1),
  };

  return pathItem;
};

export const getFolder = (path: string): string => {
  return path.substring(0, path.indexOf("/"));
};

export const getFile = (path: string): string => {
  return path.substring(path.indexOf("/") + 1);
};

export const verifyExtension = (path: string, extension: string): string => {
  let fileName: string = path;
  if (fileName.lastIndexOf(".") === -1) {
    fileName = `${fileName}.${extension}`;
  }
  return fileName;
};

export const getFileExtension = (path: string): string => {
  const index = path?.lastIndexOf(".");
  if (path.length > 0 && index > 0) {
    return path.substring(index+1);
  }
  return "";
} 

export const replaceExtension = (path: string, extension: string): string => {
  let fileName: string = path;
  const dotIndex = fileName.lastIndexOf(".");
  if (dotIndex === -1) {
    fileName = `${fileName}.${extension}`;
  } else {
    fileName = `${fileName.substring(0, dotIndex)}.${extension}`;
  }
  return fileName;
};

export const fileToBase64 = (file: File | Blob): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
     const base64String = reader.result as string;
     resolve(base64String.replace(/^data:.*;base64,/, "")); 
    };

    reader.readAsDataURL(file);
    reader.onerror = reject;
  });
